import { useLayoutEffect, useRef } from 'react'
import { Box, Typography } from '@mui/material'
import { registerChatPageSlot } from './chatPageSlot'

/**
 * SC-473: the main-menu Chat page. It renders no chat itself — it only provides the placeholder
 * the single app-level MatrixChatMount docks onto, so the dashboard and the in-game popup share
 * one mounted panel (and one Matrix client). `unavailable` (guests, who get no company chat)
 * shows a message instead and registers no slot.
 */
export default function ChatPage({ unavailable = false }: Readonly<{ unavailable?: boolean }>) {
  const ref = useRef<HTMLDivElement | null>(null)

  useLayoutEffect(() => {
    const el = ref.current
    if (unavailable || !el) return
    return registerChatPageSlot(el)
  }, [unavailable])

  if (unavailable) {
    return (
      <Box sx={{ p: 3 }}>
        <Typography color="text.secondary">Chat isn&apos;t available for guest accounts.</Typography>
      </Box>
    )
  }
  return <Box ref={ref} data-testid="chat-page-slot" sx={{ flex: 1, minHeight: 0, height: '100%' }} />
}
